import { useParams } from "react-router-dom";
import { useState } from "react";
import projects from "../data/projects";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ImageModal from "../components/Modal/ImageModal";
import "../styles/projectDetails.css";
import { LuExpand, LuEye } from "react-icons/lu";
import { Link as RouterLink } from "react-router-dom";

export default function ProjectDetails() {
  const { type, id } = useParams();
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedALt, setSelectedAlt] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const projectId = Number(id);
  const project = projects[type]?.find((proj) => proj.id === projectId);
  if (!project) return <h2>Project not found</h2>;

  return (
    <>
      <Navbar />
      <div className="project-details">
        <div className="project-details__container">
          <div className="project-details__hero">
            <h1>{project.title}</h1>
            <div className="project-details__tags">
              {project.tags.map((tag, index) => (
                <span key={index}>{tag}</span>
              ))}
            </div>
          </div>
          <div className="project-details__image-holder">
            <img
              className="project-details__image"
              src={project.image}
              alt={project.title}
            />
            <div className="tab-content__item__action">
              <button
                className="tab-content__item__action-expand"
                onClick={() => {
                  setModalOpen(true);
                  setSelectedImage(project.image);
                  setSelectedAlt(project.title);
                }}
              >
                <LuExpand />
              </button>
              {project.flag === "special" ? (
                <RouterLink
                  className="tab-content__item__action-preview"
                  to={`${project.path}`}
                  target="_blank"
                >
                  <LuEye />
                  <span>live preview</span>
                </RouterLink>
              ) : (
                <RouterLink
                  className="tab-content__item__action-preview"
                  to={`/preview/${project.type}/${project.id}`}
                >
                  <LuEye />
                  <span>live preview</span>
                </RouterLink>
              )}

            </div>
          </div>
          <div className="project-details__info">
            <p>{project.description}</p>
          </div>
        </div>
        <ImageModal
          visibility={`modal-control ${modalOpen && "modal-control--active"}`}
          imageSrc={selectedImage}
          imageAlt={selectedALt}
          onClose={() => {
            setModalOpen(false);
            setTimeout(() => {
              setSelectedImage(null);
            }, 600);
          }}
        />
      </div>
      <Footer />
    </>
  );
}
